var surveyGenerator = {
  formFields: { 
    text : {
      type: "text",
      name: "",
      title: 'TextInput',
      isRequired: true,
    },
     datepicker : {
      name: "",
      type: "datepicker",
      inputType: "date",
      title: "<Fragetext>",
      dateFormat: "mm/dd/yy",
      isRequired: true
    },
    matrix: {
      type: "matrix",
      isRequired: true,
      name: "",
      title:
        "<Fragetext>",
      columns: [
        {
          value: 1,
          text: "Trifft überhaupt nicht zu"
        },
        {
          value: 2,
          text: "Trifft nicht zu"
        },
        {
          value: 3,
          text: "Trifft eher nicht zu"
        },
        {
          value: 4,
          text: "Trifft eher zu"
        },
        {
          value: 5,
          text: "Trifft zu"
        },
        {
          value: 6,
          text: "Trifft voll und ganz zu"
        },
      ],
      rows: [
      ]
    },
    rating: {
      type: "rating",
      isRequired: true,
      name: "",
      title: "<Fragetext>",
      mininumRateDescription: "Sehr unzufrieden",
      maximumRateDescription: "Sehr zufrieden"
    },
    ratingDependant: {
      type: "rating",
      isRequired: true,
      name: "recommend friends",
      visibleIf: "{satisfaction} > 3",
      title:
        "How likely are you to recommend the Product to a friend or co-worker?",
      mininumRateDescription: "Will not recommend",
      maximumRateDescription: "I will recommend"
    },
    comment: {
      type: "comment",
      isRequired: true,
      name: "suggestions",
      title: "<Fragetext>"
    },
    radiogroup: {
      type: "radiogroup",
      isRequired: true,
      name: "",
      title: "<Fragetext>",
      choices: [
      ]
    },
    multipleText: {
      type: "multipletext",
      isRequired: true,
      name: "",
      title: "<Fragetext>",
      items: [
        {
          name: "mostamount",
          title:
            "Most amount you would every pay for a product like ours"
        },
        {
          name: "leastamount",
          title: "The least amount you would feel comfortable paying"
        }
      ]
    }
  },
  defaultSchema:{
    title: "Umfrage zu ",
    showProgressBar: "top",
    pages: []
  },
  buildSchemaForSurvey(questions, surveyDetails, module){
    
    let pages = this.addSchemaGroupsForPages(questions.map(elem => elem.page), module);

    questions.forEach(question => {
      if(question.answerOptions != "" && typeof question.answerOptions != 'object'){
        question.answerOptions = JSON.parse(question.answerOptions);
      }
      let field = this.generateFieldForQuestion(question);
      let page = pages.find(elem => elem.pageType == question.page);
      if(page != null) page.questions.push(field);
    })
    this.defaultSchema.pages = pages;
    this.defaultSchema.title = surveyDetails.title;
    pages.forEach(p => p.questions.sort(({position:a},{position:b}) => a-b));
    if(surveyDetails.customTitlePage == true){
      let titlePage = this.buildTitlePageForSurvey(surveyDetails.description);
      this.defaultSchema.pages.unshift(titlePage);
    }
    return {...this.defaultSchema};
  },
  buildManualSchemaForSurvey(groups, surveyDetails){
    let pages = [];
    groups.forEach(group => {
      let page = {
        title:"",
        pageType: "",
        questions: []
      }
      page.title = group.title;
      page.pageType = 'CUSTOM';
      
      group.questions.forEach(question => {
        if(question.answerOptions != ""){
          try{
            question.answerOptions = JSON.parse(question.answerOptions);
          }catch(e){}
        }
        let field = this.generateFieldForQuestion(question);
        page.questions.push(field)
      })
      pages.push(page);
    })
    this.defaultSchema.pages = pages;
    this.defaultSchema.title = surveyDetails.surveyTitle;
    if(surveyDetails.customTitlePage == true){
      
      let titlePage = this.buildTitlePageForSurvey(surveyDetails.description);
      this.defaultSchema.pages.unshift(titlePage);
    }
    return {...this.defaultSchema};
  },
  buildQuestionPreview(questionText, answerType, answerOptions){
    const question = {
      text: questionText,
      answerType: answerType,
      answerOptions: (answerOptions != null && answerOptions.length > 0) ? JSON.parse(answerOptions):null
    }
    let field = this.generateFieldForQuestion(question);
    let questions = [];
    questions.push(field);
    return {questions: questions};
  },
  buildSchemaProcessSurvey(elementsWithQuestions, surveyDetails, uuid){ 
    let uniqueElementIds = [...new Map(elementsWithQuestions.map(item =>
      [item['elementId'], item])).values()]
    let pages = this.addSchemaGroupsForProcessElements(uniqueElementIds);
      elementsWithQuestions.forEach(elementQuestion => {
        if(elementQuestion.question.answerOptions != ""){
          elementQuestion.question.answerOptions = JSON.parse(elementQuestion.question.answerOptions);
        }
        let field = this.generateFieldForQuestion(elementQuestion.question);
        field.name = elementQuestion.question.id+"_"+elementQuestion.elementId;
        pages.find(elem => elem.name == elementQuestion.elementId).questions.push(field)
      })

      let schema = {...this.defaultSchema}
      schema.pages = pages;
      schema.title = surveyDetails.title;
      schema.uuid = uuid;

      if(surveyDetails.customTitlePage == true){
        let titlePage = this.buildTitlePageForSurvey(surveyDetails.description);
        schema.pages.unshift(titlePage);
      }

      return schema;
  },
  generateFieldForQuestion(question){
    let field = {...this.formFields[question.answerType.toLowerCase()]};
    if(question.text != ""){
      field.title = question.text;
    }else{
      field.title = "<Fragetext>"
    }
    if(question.answerOptions != null && question.answerType == "RADIOGROUP"){
      field.choices = question.answerOptions.map(elem => elem.value).filter(elem => elem != "");
    }else if(question.answerType == "MATRIX"){
      let rows = [];
      rows.push({
        value: 0,
        text: question.text
      })
      field.rows = rows;
      field.title = " ";
    }
    field.name = question.id;
    field.position = question.position;
    field.inverted = question.answerRatingInverted;
    return field;
  },
  addSchemaGroupsForQuestionTypes(types){
    let groups = [];
    if(types.includes('USER')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Nutzerfragen";
      group.pageType = 'USER';
      groups.push(group);
    }
    if(types.includes('PROCESS')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Prozessfragen";
      group.pageType = 'PROCESS';
      groups.push(group);
    }
    if(types.includes('ACTIVITY')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Aktivitätsfragen";
      group.pageType = 'ACTIVITY';
      groups.push(group);
    }
    if(types.includes('ROLE')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Rollenfragen";
      group.pageType = 'ROLE';
      groups.push(group);
    }
    if(types.includes('NONE')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Weitere Fragen";
      group.pageType = 'NONE';
      groups.push(group);
    }
    
    return groups;
  },
  addSchemaGroupsForPages(types, module){
    let groups = [];
    if(module == 1){
      if(types.includes('P1')){
        let group = {
          title:"",
          pageType: "",
          questions: []
        }
        group.title = "Fragen zu Ihrer Beschäftigung";
        group.pageType = 'P1';
        groups.push(group);
      }
      if(types.includes('P2')){
        let group = {
          title:"",
          pageType: "",
          questions: []
        }
        group.title = "Fragen zu Ihrer Person";
        group.pageType = 'P2';
        groups.push(group);
      }
    }else if(module == 2){
      if(types.includes('P1')){
        let group = {
          title:"",
          pageType: "",
          questions: []
        }
        group.title = "Ihre aktuelle Arbeit ";
        group.pageType = 'P1';
        groups.push(group);
      }
      if(types.includes('P2')){
        let group = {
          title:"",
          pageType: "",
          questions: []
        }
        group.title = "Ihre persönlichen Vorlieben bei Ihrer Arbeit";
        group.pageType = 'P2';
        groups.push(group);
      }
    }
    if(types.includes('P3')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zu Ihrer Zufriedenheit mit dem/der aktuellen Arbeitgeber/Arbeitgeberin";
      group.pageType = 'P3';
      groups.push(group);
    }
    if(types.includes('P4')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zur Zufriedenheit mit der aktuellen Arbeit";
      group.pageType = 'P4';
      groups.push(group);
    }
    if(types.includes('P5')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zur Ausgestaltung  des Arbeitsprozesses";
      group.pageType = 'P5';
      groups.push(group);
    }
    if(types.includes('P6')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zu Ihrer Rolle bei den Aktivitäten in diesem Arbeitsprozess";
      group.pageType = 'P6';
      groups.push(group);
    }
    if(types.includes('P7')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zu Ihrem sozialen Umfeld in dem Arbeitsprozess";
      group.pageType = 'P7';
      groups.push(group);
    }
    if(types.includes('P8')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zu Ihren Arbeitsbedingungen im Arbeitsprozess";
      group.pageType = 'P8';
      groups.push(group);
    }
    if(types.includes('B1')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zu ihren Arbeitsinhalten und Arbeitsaufgaben";
      group.pageType = 'B1';
      groups.push(group);
    }
    if(types.includes('B2')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zu ihrer Arbeitsorganisation";
      group.pageType = 'B2';
      groups.push(group);
    }
    if(types.includes('B3')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zu ihren sozialen Beziehungen im Bezug auf ihre Beschäftigung";
      group.pageType = 'B3';
      groups.push(group);
    }
    if(types.includes('B4')){
      let group = {
        title:"",
        pageType: "",
        questions: []
      }
      group.title = "Fragen zu ihrenArbeitsmitteln und ihrer Arbeitsumgebung";
      group.pageType = 'B4';
      groups.push(group);
    }
    
    return groups;
  },
  addSchemaGroupsForProcessElements(elements){
    let groups = [];
    elements.forEach(elem => {
      let group = {
        title:"",
        name: "",
        questions: []
      }
      if(elem.elementId.includes("Flow") && (elem.friendlyName == null || elem.friendlyName == "")){
        elem.friendlyName = "Kommunikation";
      }
      group.title = elem.friendlyName;
      group.name = elem.elementId;
      if(elem.friendlyName == null || elem.friendlyName == "") group.title = group.name;
      groups.push(group);
    })
    return groups;
  },
  randomProperty(obj) {
    var keys = Object.keys(obj);
    return obj[keys[ keys.length * Math.random() << 0]];
  },
  buildTitlePageForSurvey(description){
    let firstPage ={
      "name": "Welcome",
      "elements": [
       {
        "type": "html",
        "name": "titlePage",
        "html": description
       }
      ],
      "questionTitleLocation": "hidden"
     }
     return firstPage;
  }
}
  
export default surveyGenerator;
